<template>
  <div class="index2">
    <div class="box1">
      <div class="box1_top_title">按需选基 
        <i style="font-style:normal;float:right;font-size:16px;color:#666;font-weight:normal;cursor:pointer;">查看更多
          <img style="width: 8px; height: 14px" src="../../../public/img/IndexValuation/right_la.png"/></i>
      </div>
      <div class="box1_top_button">
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation == 0 }" @click="change_top_button(0)">稳健理财</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation == 1 }" @click="change_top_button(1)">平衡优选</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation == 2 }" @click="change_top_button(2)">积极进取</div>
      </div>
      <div class="box1_content">
        <div class="box1_content_options1" v-for="(item,index) in data1" :key="'1' + index">
          <div class="box1_content_options1_top">招商中证白酒指数A</div>
          <div class="box1_content_options1_center">
            <div class="box1_content_options1_center_left">
              <div class="box1_content_options1_center_left_top">+11.90%</div>
              <div class="box1_content_options1_center_left_bottom">近1年涨跌幅</div>
            </div>
            <div class="box1_content_options1_center_right">
              <div class="box1_content_options1_center_right_top">连续5年正收益</div>
              <div class="box1_content_options1_center_right_bottom">
                <div class="box1_content_options1_center_right_bottom_left">中高风险</div>
                <div class="box1_content_options1_center_right_bottom_right">明星经理</div>
              </div>
            </div>
          </div>
          <div class="box1_content_options1_bottom">
            <i class="box1_content_options1_bottom_text1">解读 |</i>
            <i class="box1_content_options1_bottom_text2">适合投资新手 兼顾收益和风险</i>
          </div>
        </div>
      </div>
    </div>

    <div class="box2">
      <div class="box1_top_title">明星基金
        <i style="font-style:normal;float:right;font-size:16px;color:#666;font-weight:normal;cursor:pointer;">查看更多
          <img style="width: 8px; height: 14px" src="../../../public/img/IndexValuation/right_la.png"/></i>
      </div>
      <div class="box1_top_button">
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation3 == 0 }" @click="change_top_button3(0)">金牛奖</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation3 == 1 }" @click="change_top_button3(1)">五星基金</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation3 == 2 }" @click="change_top_button3(2)">常胜将军</div>
      </div>
      <div class="box1_top_button">
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation2 == 0 }" @click="change_top_button2(0)">混合型</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation2 == 1 }" @click="change_top_button2(1)">股票型</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation2 == 2 }" @click="change_top_button2(2)">指数型</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation2 == 3 }" @click="change_top_button2(3)">债券型</div>
      </div>
      <div class="box1_content">
        <div class="box1_content_options1" v-for="(item,index) in data1" :key="'1' + index">
          <div class="box1_content_options1_top">招商中证白酒指数A</div>
          <div class="box1_content_options1_center">
            <div class="box1_content_options1_center_left">
              <div class="box1_content_options1_center_left_top">+11.90%</div>
              <div class="box1_content_options1_center_left_bottom">近1年涨跌幅</div>
            </div>
            <div class="box1_content_options1_center_right">
              <div class="box1_content_options1_center_right_top">连续5年正收益</div>
              <div class="box1_content_options1_center_right_bottom">
                <div class="box1_content_options1_center_right_bottom_left">中高风险</div>
                <div class="box1_content_options1_center_right_bottom_right">明星经理</div>
              </div>
            </div>
          </div>
          <div class="box1_content_options1_bottom">
            <i class="box1_content_options1_bottom_text1">解读 |</i>
            <i class="box1_content_options1_bottom_text2">适合投资新手 兼顾收益和风险</i>
          </div>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="box1_top_title">热门主题 
        <i style="font-style:normal;float:right;font-size:16px;color:#666;font-weight:normal;cursor:pointer;">查看更多
          <img style="width: 8px; height: 14px" src="../../../public/img/IndexValuation/right_la.png"/></i>
      </div>
      <div class="box1_content" style="margin-top:24px;">
        <div class="box1_content_options1" v-for="(item,index) in data1" :key="'2' + index">
          <div class="box1_content_options1_top">招商中证白酒指数A</div>
          <div class="box1_content_options1_center">
            <div class="box1_content_options1_center_left">
              <div class="box1_content_options1_center_left_top">+11.90%</div>
              <div class="box1_content_options1_center_left_bottom">近1年涨跌幅</div>
            </div>
            <div class="box1_content_options1_center_right">
              <div class="box1_content_options1_center_right_top">连续5年正收益</div>
              <div class="box1_content_options1_center_right_bottom">
                <div class="box1_content_options1_center_right_bottom_left">中高风险</div>
                <div class="box1_content_options1_center_right_bottom_right">明星经理</div>
              </div>
            </div>
          </div>
          <div class="box1_content_options1_bottom2">
            <i class="box1_content_options1_bottom_text1">热点解读 |</i>
            <i class="box1_content_options1_bottom_text2">北交所开市前三日，交易热度较高，10只次新股平均涨幅为146.80%</i>
          </div>
        </div>
      </div>
    </div>
    <div class="box4">
      <div class="box1_top_title">全部基金</div>
      <div class="box1_top_button">
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == index }" @click="change_top_button4(index,item.id)" v-for="(item,index) in sortlist" :key="'3'+ index">{{item.name}}</div>
      </div>
      <div class="box1_top_button" v-show="sortlist2.length">
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == index }" @click="change_top_button5(index,item.id)" v-for="(item,index) in sortlist2" :key="'4'+ index">{{item.name}}</div>
      </div>
      <Table1 @getlist='getlist' :list='list' @changelist='changelist' @getmorelist='getmorelist' ref="table_table"></Table1>
    </div>
  </div>
</template>

<script>
import Table1 from './table/table1.vue'
import {fundCategoryList,dataListList} from '../../http/index.js'
export default {
  data(){
    return{
      bxjj_navigation:0,
      bxjj_navigation2:0,
      bxjj_navigation3:0,
      bxjj_navigation4:0,
      bxjj_navigation5:0,
      data1:[{},{},{},{}],
      sortlist:[],             //一级分类
      sortlist2:[],          //二级分类
      sort_id:'',            //当前一级分类id
      sort2_id:'',          //当前二级分类id
      list:[],
      page:1,
    }
  },
  methods:{

    change_top_button(e){
      this.bxjj_navigation = e
    },
    change_top_button2(e){
      this.bxjj_navigation2 = e
    },
    change_top_button3(e){
      this.bxjj_navigation3 = e
    },
    change_top_button4(e,m){
      this.bxjj_navigation4 = e
      this.sort_id = m
      this.sort2_id = ''
      this.bxjj_navigation5 = 0
      this.$refs.table_table.initpage()
      this.page = 1
      this.initsort2(m)
      this.initlist()
    },
    change_top_button5(e,m){
      this.bxjj_navigation5 = e
      this.sort2_id = m
      this.page = 1
      this.$refs.table_table.initpage()
      this.initlist()
    },
    initsort(){
      fundCategoryList().then((res)=>{
        this.sortlist = res.data
        this.bxjj_navigation4 = 0
        this.sort_id = this.sortlist[0].id
        this.initlist()
      }).catch((err)=>{
        console.log(err);
      })
    },
    initsort2(e){
      let pid = e
      fundCategoryList({pid}).then((res)=>{
        this.sortlist2 = res.data
        this.sort2_id = this.sortlist2[0].id
        this.initlist()
      }).catch((err)=>{
        console.log(err);
      })
    },
    initlist(e){
      let category_id
      if(this.sort2_id != ''){
        category_id = this.sort2_id
      }else {
        category_id = this.sort_id
      }
      let page = this.page
      let page_number = 20
      let params
      if(e){
        params = Object.assign({},{category_id,page,page_number},e)
      }else{
        params = Object.assign({},{category_id,page,page_number})
      }
      if(this.page == 1){
        this.list = []
      }
      dataListList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
        }else{
          this.list = this.list.concat(res.data.list)
        }
        
      }).catch((err)=>{
        console.log(err);
      })
    },
    getlist(){
      this.initlist()
    },
    changelist(e){
      this.page = 1
      this.$refs.table_table.initpage()
      if(e){
        this.initlist(e)
      }else {
        this.initlist()
      }
    },
    getmorelist(){
      this.page ++ 
      this.initlist()
    }
  },
  components: {
    Table1,
  },
  mounted(){
    this.initsort()
  }
};
</script>

<style scoped>
i {
  font-style: normal;
}
.index2 {
  margin-bottom: 50px;
}
.box1 {
  width: calc(100% - 48px);
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
}
.box1_top_title {
  font-size: 18px;
  color: #000000;
  line-height: 1;
  font-weight: bold;
}
.box1_top_button{
  display: flex;
  align-content: center;
  margin-bottom: 30px;
  position: relative;
  margin-top: 20px;
}
.box1_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box1_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box1_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box1_top_button_button3 {
  font-size: 16px;
  color: #666666;
  margin-left: 40px;
  cursor: pointer;
}
.box1_top_button_button3:nth-child(1) {
  margin-left: 0px;
}
.box1_top_button_button4{
  color: #fcad2a;
  position: relative;
}
.box1_top_button_button4::after{
  content: " ";
  display: block;
  width: 30px;
  height: 3px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -9px;
  left: calc(50% - 15px)
}
.box1_content{
  display: flex;
  justify-content: space-between; 
}
.box1_content_options1{
  width: 302px;
	/* height: 127px; */
	background-color: #ffffff;
	box-shadow: 0px 4px 16px 2px 
		rgba(152, 152, 152, 0.13);
	border-radius: 3px;
  padding: 24px 23px;
  display: flex;
  flex-direction: column;
}
.box1_content_options1_top{
  font-size: 18px;
	font-weight: bold;
	color: #000000;
  line-height: 1;
}
.box1_content_options1_center{
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
}
.box1_content_options1_center_left_top{
	font-size: 18px;
	color: #fd4c4c;
  line-height: 1;
}
.box1_content_options1_center_left_bottom{
	font-size: 16px;
	color: #999999;
  line-height: 1;
  margin-top: 10px;
}
.box1_content_options1_center_right_top{
  font-size: 16px;
  line-height: 1;
	color: #333333;
  text-align: right;
}
.box1_content_options1_center_right_bottom{
  display: flex;
  margin-top: 5px;
}
.box1_content_options1_center_right_bottom_left{
  width: 60px;
	height: 20px;
	border-radius: 3px;
	border: solid 1px #fcad2a;
  font-size: 12px;;
	line-height: 20px;
	color: #fcad2a;
  text-align: center;
}
.box1_content_options1_center_right_bottom_right{
  width: 60px;
	height: 20px;
	border-radius: 3px;
	border: solid 1px #539cff;
  font-size: 12px;;
	line-height: 20px;
	color: #539cff;
  text-align: center;
  margin-left: 12px;
}
.box1_content_options1_bottom{
  width: calc(100% - 24px);
	/* height: 17px; */
  line-height: 17px;
	background-image: url('../../../public/img/index2/bg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
	border-radius: 6px;
  margin-top: 17px;
  padding: 7px 12px;
  /* display: flex; */
}
.box1_content_options1_bottom2{
  width: calc(100% - 24px);
	/* height: 17px; */
  line-height: 17px;
	background-image: url('../../../public/img/index2/bg2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
	border-radius: 6px;
  margin-top: 17px;
  padding: 7px 12px;
  /* display: flex; */
}
.box1_content_options1_bottom_text1{
  font-size: 12px;
  line-height: 17px;
	color: #fcad2a;
}
.box1_content_options1_bottom_text2{
  font-size: 12px;
  line-height: 17px;
	color: #333333;
  margin-left: 5px;
}
.box2 {
  width: calc(100% - 48px);
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box3 {
  width: calc(100% - 48px);
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
.box4 {
  width: calc(100% - 48px);
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  margin-top: 24px;
}
</style>